export enum ReassignDisputeFormLabelsEnum {
  TITLE = 'Reassign Dispute',
  CANCEL = 'Cancel',
  REASSIGN = 'Reassign',
  REASON_CODE = 'Reason Code',
  REASON_FOR_REASSIGNMENT = 'Reason For Reassignment',
}
